/** El recuadro del cambio de inicio de sesión en la pantalla de entrada (hasta AVISO_LOGIN_HASTA). */
export const AvisoNuevoLogin = () => (
  <div role="note" className="mt-4 rounded-md border border-primary/30 bg-primary-soft p-3 text-sm text-primary-soft-foreground text-left">
    <p className="font-semibold">Cambió el inicio de sesión.</p>
    <p className="mt-1">
      Tocá "Iniciar sesión" y entrá con tu email (va donde dice "Nombre de usuario") y tu DNI. Si no podés entrar,
      contactá a tu supervisor.
    </p>
  </div>
);
